import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import RenovacaoInscricaoLayer from "../components/RenovacaoInscricaoLayer";
import { useTranslation } from "../i18n/I18nContext";

const RenovacaoInscricaoPage = () => {
  const { t } = useTranslation();
  return (
    <MasterLayout>
      <Breadcrumb title={t("renovacao.breadcrumb")} />
      <RenovacaoInscricaoLayer />
    </MasterLayout>
  );
};

export default RenovacaoInscricaoPage;
